import React from 'react'
import { useSelector, } from 'react-redux'
import { ThemeProvider, } from 'styled-components'
import { BrowserRouter, Route, Routes, } from 'react-router-dom'

import { Signin, MainDashboard, } from '@pages'

import { RootState, } from '@reducers'

import { THEMES, GlobalStyle, } from '@styles'

type AppErrorBoundaryState = {
  hasError: boolean
}

class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, AppErrorBoundaryState> {
  state = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    }
  }

  componentDidCatch(error: Error) {
    console.error(error)
  }

  render() {
    if(this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'rgb(51, 65, 85)',
          fontSize: 16,
          fontWeight: 700,
        }}>
          화면을 표시하는 중 문제가 발생했습니다. 새로고침 후 다시 시도해주세요.
        </div>
      )
    }

    return this.props.children
  }
}

function App() {
  const token = useSelector((state: RootState) => state.account.token)

  return (
    <ThemeProvider theme={ THEMES }>
      <GlobalStyle />
      <AppErrorBoundary>
        <BrowserRouter>
          {
            token ? (
              <Routes>
                <Route path='/' element={ <MainDashboard /> } />
                <Route path='/agents/:agentId' element={ <MainDashboard /> } />
              </Routes>
            ) : (
              <Signin />
            )
          }
        </BrowserRouter>
      </AppErrorBoundary>
    </ThemeProvider>
  )
}

export default App
